import constants, { LOGIN_SOURCE_TTU } from '../constants';

const processLoginUserData = ({
  email,
  mobileNumber,
  isRegistered,
  fieldsData,
  loginType,
  sourceType,
  userInfo,
  source,
  ttuUserName
}) => {
  const data = { email, mobileNumber };
  if (
    !(isRegistered && loginType === constants.LOGIN_TYPE_NUMBER) &&
    email === '' &&
    fieldsData.email.value
  )
    data.email = fieldsData.email.value;

  // In case the user is already registered but does not have an email attached to their account.
  if (
    isRegistered &&
    loginType === constants.LOGIN_TYPE_NUMBER &&
    email === '' &&
    fieldsData.email.value
  )
    data.email = fieldsData.email.value;
  if (mobileNumber === '' && fieldsData.phone)
    data.mobileNumber = fieldsData.phone.value;
  if (sourceType === 'marketing' && userInfo.email) {
    data.email = userInfo.email;
    data.mobileNumber = userInfo.phoneNumber;
  }

  const nameValue =
    source === LOGIN_SOURCE_TTU && ttuUserName
      ? ttuUserName
      : fieldsData.name?.value;
  const arr = nameValue ? nameValue.split(' ') : [''];
  let firstName = arr[0] ? arr[0] : '';
  let lastName = arr.length > 1 ? arr[1] : '';
  if (userInfo.name) {
    const splitName = userInfo.name.split(' ');
    firstName = splitName?.[0] ?? '';
    lastName = splitName?.[1] ?? '';
  }

  return { data, firstName, lastName };
};

export default processLoginUserData;
